import { AMLS_COMMON } from './globalConstants';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';

export const COMMON_CONSTANTS = {
  BASE_URL: AMLS_COMMON,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    // Authorization: `${TOKEN_ID}`
    Authorization: `Bearer ${TOKEN_ID}`
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData'
};
export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const FRAUD_PREVENTION_SOURCE_IDS = [25, 29];

export const UNIFIED_ALERT_METRICS = {
  ALERT_RAISED: 'alertraised',
  SARS: 'sars',
  OPEN: 'open',
  CLOSED: 'closed',
  UNDER_INVESTIGATION: 'underinvestigation',
  ASSIGNED: 'assigned',
  PENDING_APPROVAL: 'pendingapproval',
  ALERT_COUNT: 'alertcount',
  ANOMALY_COUNT: 'anomalycount',
  COUNT_FOR_PAGINATION: 'countforpagination'
};

/**
 * Numeric AlertSource module IDs.
 * Mirrors `be/util/src/main/scala/com/tookitaki/amls/common/enums/AlertSource.scala`.
 * Used on pages whose alert-context API does not return `alertSourceId`, so the FE must
 * supply the moduleId explicitly (otherwise `TransactionDetails` falls back to the user's
 * `currentProductLogin.moduleId` which is unrelated to the alert).
 */
export const ALERT_SOURCE_MODULE_IDS = {
  MANUAL_CASE: 15
};

export const TRANSACTION_HISTORY_MODULES = {
  // TM / CRS direct-login users
  TM_TRANSACTION_HISTORY: 'TM_TRANSACTION_HISTORY',
  CRS_TRANSACTION_HISTORY: 'CRS_TRANSACTION_HISTORY',

  // CM user viewing a standalone alert
  CM_TM_TRANSACTION_HISTORY: 'CM_TM_TRANSACTION_HISTORY',
  CM_CRS_TRANSACTION_HISTORY: 'CM_CRS_TRANSACTION_HISTORY',

  // CM user inside a case (alert tab)
  CM_CASE_TM_TRANSACTION_HISTORY: 'CM_CASE_TM_TRANSACTION_HISTORY',
  CM_CASE_CRS_TRANSACTION_HISTORY: 'CM_CASE_CRS_TRANSACTION_HISTORY',

  // CM user on take-action of an automated case (cross-alert)
  CM_CASE_TRANSACTION_HISTORY: 'CM_CASE_TRANSACTION_HISTORY',

  // CM user in a manual case
  CM_MANUAL_CUSTOMER_TRANSACTION_HISTORY:
    'CM_MANUAL_CUSTOMER_TRANSACTION_HISTORY'
};

/**
 * Resolve the correct async-download module string from context.
 *
 * @param {boolean} isFromCM  - true when the user is accessing via Case Management
 * @param {boolean} isCaseAlert - true when the alert is viewed inside a CM case tab
 * @param {boolean} isCrsAlert  - true when the alert is a CRS-type alert
 */
export const resolveDownloadModule = ({
  isFromCM = false,
  isCaseAlert = false,
  isCrsAlert = false
} = {}) => {
  if (!isFromCM) {
    return isCrsAlert
      ? TRANSACTION_HISTORY_MODULES.CRS_TRANSACTION_HISTORY
      : TRANSACTION_HISTORY_MODULES.TM_TRANSACTION_HISTORY;
  }

  if (isCaseAlert) {
    return isCrsAlert
      ? TRANSACTION_HISTORY_MODULES.CM_CASE_CRS_TRANSACTION_HISTORY
      : TRANSACTION_HISTORY_MODULES.CM_CASE_TM_TRANSACTION_HISTORY;
  }

  return isCrsAlert
    ? TRANSACTION_HISTORY_MODULES.CM_CRS_TRANSACTION_HISTORY
    : TRANSACTION_HISTORY_MODULES.CM_TM_TRANSACTION_HISTORY;
};
